const GA4 = process.env.REACT_APP_GA4_ID;
const PIXEL = process.env.REACT_APP_META_PIXEL_ID;
let loaded = false;

function inject(src) {
  const s = document.createElement("script");
  s.async = true;
  s.src = src;
  document.head.appendChild(s);
}

export function loadTracking() {
  if (loaded || localStorage.getItem("cookie_consent") !== "all") return;
  loaded = true;
  if (GA4) {
    inject(`https://www.googletagmanager.com/gtag/js?id=${GA4}`);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", GA4, { anonymize_ip: true });
  }
  if (PIXEL) {
    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) { if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); }; if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = []; t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s); })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    /* eslint-enable */
    window.fbq("init", PIXEL);
    window.fbq("track", "PageView");
  }
}

export function trackEvent(name, params = {}) {
  if (window.gtag) window.gtag("event", name, params);
  if (window.fbq) window.fbq("track", name === "generate_lead" ? "Lead" : name === "mandate_signed" ? "CompleteRegistration" : name, params);
}
